import useFeatureFlag, { FEATURE_FLAGS } from '@/utils/featureFlags';

export const useMyMoneySavedReceiptsFeatureFlag = () => {
  const isUseMyMoneySavedReceiptsEnabled = useFeatureFlag(FEATURE_FLAGS.USE_MY_MONEY_SAVED_RECEIPTS);
  return { isUseMyMoneySavedReceiptsEnabled };
};
